export default __webpack_public_path__ + "static/media/Gary_Yansen_Resume.0da91ac2.pdf";